const isMobile = () => window.matchMedia('(max-width: 991.98px)').matches;

const sections = document.querySelectorAll('.section-problem-solutions');

sections.forEach((section) => {
  const toggles = section.querySelectorAll('.section-problem-solutions-buttons > div');
  const columns = section.querySelectorAll('.row .col-lg-6');

  if (toggles.length < 2 || columns.length < 2) {
    return;
  }

  const [problemToggle, solutionToggle] = toggles;
  const [problemColumn, solutionColumn] = columns;

  const activate = (targetToggle) => {
    toggles.forEach((btn) => btn.classList.remove('active'));
    targetToggle.classList.add('active');
  };

  const scrollToTarget = (target) => {
    if (!target) return;

    const offset = 70;
    const top = target.getBoundingClientRect().top + window.scrollY - offset;

    window.scrollTo({
      top,
      behavior: 'smooth',
    });
  };

  problemToggle.addEventListener('click', () => {
    activate(problemToggle);
    if (isMobile()) {
      scrollToTarget(problemColumn);
    }
  });

  solutionToggle.addEventListener('click', () => {
    activate(solutionToggle);
    if (isMobile()) {
      scrollToTarget(solutionColumn);
    }
  });
});
